<template>
  <draggable
    v-model="localSubTasks"
    class="task__tasks"
    :class="{'task__tasks_mobile': $vuetify.breakpoint.xsOnly}"
    @change="changeSequence($event)"
    @start="startSequence()"
    handle=".task__drag-2"
  >
    <div
      v-for="(task, key) in localSubTasks"
      :key="'sub-task-'+key"
    >
      <div
        v-if="task !== undefined"
        class="task__task"
      >
        <div class="task__mark">
          <check-mark
            v-model="task.is_done"
            :id="projectId"
            :sub-id="task.id"
            action-change-false="changeTaskStatusNew"
            action-change-true="changeTaskStatusDone"
          ></check-mark>
        </div>
        <div
          class="task__name"
          @click="$emit('open-sub-task', task)"
        >{{ task.name }}
        </div>
        <div class="task__tags">
          <tag
            v-for="(tag, key) in task.tag"
            :key="key"
            style="margin: 0 2px;"
            :label="tag"
          ></tag>
        </div>
        <div class="task__drag task__drag-2">
          <v-icon
            class="drag"
          >mdi mdi-drag
          </v-icon>
        </div>
      </div>
    </div>
  </draggable>
</template>

<script>
import Draggable from 'vuedraggable';
import CheckMark from '../../../ui/CheckMark';
import Tag from "../../../ui/Tag";

export default {
  components: {Draggable, CheckMark, Tag},
  props: {
    projectId: Number,
    subTasks: Array,
    taskId: Number
  },
  data() {
    return {
      localSubTasks: this.subTasks,
      changeSeqId: 0,
      changeSeq: {
        prev_id: 0,
        next_id: 0,
        task_id: this.taskId
      },
      sequenceModels: this.subTasks,
    }
  },
  watch: {
    subTasks(v) {
      this.localSubTasks = v;
    },
    localSubTasks(v) {
      this.$emit('update:subTasks', v);
    },
    taskId(v) {
      this.changeSeq.task_id = v;
    }
  },
  methods: {
    changeSequence(event) {

      let res = this.recountSequenceModels(this.localSubTasks, this.sequenceModels, event);

      this.sequenceModels = res.models;

      this.$store.dispatch('changeTaskSequence', {
        id: this.projectId,
        subId: res.id,
        data: {
          from_seq: res.from,
          to_seq: res.to,
        },
      });
    },
    startSequence() {
      this.sequenceModels = this.localSubTasks;
    },
  }
}
</script>